// The consent the first visit asks for (IDD D-HP-SITE-027, D-HP-SITE-028, D-SAAS-176). The version is the
// privacy statement's date with a running suffix: a stored decision of an older version asks again.
export const PRIVACY_VERSION = '2026-10-30.3';
export const CONSENT_STORAGE_KEY = 'paioneer_consent';
// Former consent keys and cookies; they are removed so the new dialog asks once.
export const LEGACY_CONSENT_KEYS = ['cookie_consent_settings'];
export const LEGACY_CONSENT_COOKIES = ['analytics_enabled', 'third_party_enabled'];
// The footer's "cookie settings" reopens the dialog through this window event.
export const CONSENT_OPEN_EVENT = 'paioneer:consent-open';
